<template>
  <div>
    <div class="d-flex" style="gap: 8px">
      <v-select
        :value="form.comissaoReferencia"
        @change="setCampo('comissaoReferencia', $event)"
        :items="referencias"
        item-text="label"
        item-value="value"
        label="Referência"
        dense
        outlined
        hide-details
        style="flex: 2"
      ></v-select>
      <v-text-field
        :value="form.comissaoPercentual"
        @input="setCampo('comissaoPercentual', $event)"
        @blur="percentualTocado = true"
        label="Percentual"
        suffix="%"
        type="number"
        dense
        outlined
        :hide-details="!(percentualTocado && erroPercentual)"
        :error-messages="percentualTocado ? erroPercentual : ''"
        style="flex: 1"
      ></v-text-field>
    </div>

    <p class="caption grey--text ma-0 mt-2" style="line-height: 1.4">
      Pago apenas se o colaborador bater a meta do participante, somado ao bônus por unidade dos modelos.
      Incide sobre <strong>toda</strong> a comissão do período, sem filtro de modelo.
    </p>
  </div>
</template>

<script>
// O switch "Somar % de comissao de referencia" desapareceu: um bonus sem
// meta que o libere nao tem semantica. Este componente agora e so o
// conteudo (referencia + percentual), renderizado dentro da opcao
// "% sobre referencia" de Origem do bonus do colaborador, regida por
// form.usaMetaColaborador + form.origemBonusColaborador la em cima.
export default {
  name: "BonusComissaoReferencia",

  props: {
    form: { type: Object, required: true }
  },

  data() {
    return {
      referencias: [
        { value: "P2", label: "Comissão P2 consórcio" }
      ],
      // Task 15: "campo tocado" e estado local de UI (nao vai pro
      // form/payload). Este componente e recriado pelo v-if em
      // form.origemBonusColaborador === 2 no pai toda vez que a origem do
      // bonus muda, entao o reset ao reaparecer e automatico.
      percentualTocado: false
    };
  },

  computed: {
    // Limite alinhado com bonusColaboradorValido em metaColaboradorValidacaoUtils.js
    // (>= 1 e <= 100): antes o campo aceitava p > 0 enquanto a validacao do
    // Salvar exigia >= 1, entao um percentual de 0,5 passava aqui sem erro e
    // so bloqueava o Salvar em silencio.
    erroPercentual() {
      const p = parseFloat(this.form.comissaoPercentual);
      if (!(p >= 1)) return "Informe um percentual de no mínimo 1%";
      if (p > 100) return "O percentual não pode passar de 100";
      return "";
    }
  },

  methods: {
    setCampo(campo, valor) {
      this.$set(this.form, campo, valor);
    }
  }
};
</script>
